import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-1.5 px-4" data-id="element-59">
      <div className="flex justify-between items-center" data-id="element-60">
        <p className="text-[10px] text-gray-500 dark:text-gray-400" data-id="element-61">
          &copy; {new Date().getFullYear()} PathoPlex32. All rights reserved.
          Author: Joshin Kumar
        </p>
        <p className="text-[10px] text-gray-500 dark:text-gray-400" data-id="element-62">
          Version 1.0.0
        </p>
      </div>
    </footer>;
};